<tt-page *ngIf="!!page" class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="choicepossrule_keyno" [ttModel]="page.choicepossrule_keyno" ttReadonly></tt-input>
        <tt-select ttLabel="choice_prod_name" [(ttModel)]="page.choice_prod_id" (ttModelChange)="onChoiceProductChanged($event)" [ttData]="selectListProductChoices" ttDataId="prod_id" ttDataName="prod_name"></tt-select>
        <tt-select
            ttLabel="model_name"
            [(ttModel)]="page.model_id"
            (ttModelChange)="onModelChanged($event)"
            [ttData]="selectListModels"
            ttDataId="model_id"
            ttDataName="model_name"
            [ttShowClearButton]="page.model_id !== 'ALL'"
            ttClearValue="ALL"
        >
            <ng-container buttons>
                <tt-form-field-button ttIcon="fas fa-bars" ttType="primary" ttGoto="models"></tt-form-field-button>
                <tt-form-field-button *ngIf="page.model_id !== 'ALL'" ttIcon="fas fa-chevron-right" ttType="primary" ttGoto="modelmenu" [ttGotoParms]="{ model_id: page.model_id }"></tt-form-field-button>
            </ng-container>
        </tt-select>
        <tt-input ttLabel="prod_id" [ttModel]="page.prod_id" ttReadonly>
            <ng-container buttons>
                <tt-form-field-button *ngIf="page.prod_id > ''" ttIcon="fas fa-chevron-right" ttType="primary" (ttClick)="goToProduct(page.prod_id)"></tt-form-field-button>
            </ng-container>
        </tt-input>
        <tt-select *ngIf="page.nbr_of_products < 200" ttLabel="prod_name" [(ttModel)]="page.prod_id" (ttModelChange)="onProductNameChanged($event)" [ttData]="selectListProductNames" ttDataId="prod_id" ttDataName="prod_name" ttShowClearButton ttClearValue=""></tt-select>
        <tt-search *ngIf="page.nbr_of_products >= 200" ttLabel="prod_name" [(ttModel)]="page.prod_name" [ttSearch]="searchProducts" (ttOnSelected)="onProductSearchSelected($event)" (ttOnClear)="onProductSearchCleared()"></tt-search>
        <ng-container *ngIf="page.nbr_of_furniturefabrics > 0">
            <tt-select
                ttLabel="furniturefabrics_name"
                [(ttModel)]="page.furniturefabrics_id"
                (ttModelChange)="onFurnitureFabricsChanged($event)"
                [ttData]="selectListFurnitureFabrics"
                ttDataId="furniturefabrics_id"
                ttDataName="furniturefabrics_name"
                [ttShowClearButton]="page.furniturefabrics_id !== 'ALL'"
                ttClearValue="ALL"
            >
                <ng-container buttons>
                    <tt-form-field-button ttIcon="fas fa-bars" ttType="primary" ttGoto="furniturefabricss"></tt-form-field-button>
                    <tt-form-field-button *ngIf="page.furniturefabrics_id !== 'ALL'" ttIcon="fas fa-chevron-right" ttType="primary" ttGoto="furniturefabrics" [ttGotoParms]="{ furniturefabrics_id: page.furniturefabrics_id }"></tt-form-field-button>
                </ng-container>
            </tt-select>
        </ng-container>
        <tt-select
            ttLabel="prod_id_choosed"
            [(ttModel)]="page.choosed_prod_id"
            [ttData]="selectListChosenProducts"
            ttDataId="prod_id_choosed"
            ttDataName="prod_name_choosed"
            [ttShowClearButton]="page.choosed_prod_id > ''"
            ttClearValue=""
        >
            <ng-container buttons>
                <tt-form-field-button *ngIf="page.choosed_prod_id > ''" ttIcon="fas fa-chevron-right" ttType="primary" (ttClick)="goToProduct(page.choosed_prod_id)"></tt-form-field-button>
            </ng-container>
        </tt-select>
        <tt-checkbox ttLabel="isvalid" [(ttModel)]="page.isvalid"></tt-checkbox>
        <tt-input-number ttLabel="runorder" [(ttModel)]="page.runorder" ttTextAlign="right" ttDecimals="0"></tt-input-number>
        <tt-button-save ttText="choicepossrule_save" (ttClick)="save()" [ttLoading]="saving" ttTextAlign="center"></tt-button-save>
        <tt-button *ngIf="page.choicepossrule_keyno !== '0'" ttText="choicepossrule_delete" (ttClick)="delete()" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting" ttTextAlign="center"></tt-button>
    </tt-card>
</tt-page>
